import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Pfmfunds, PfmfundsMaintanence } from './pfmfunds.model';
import { environment } from 'src/environments/environment';
import { PfmMainService } from '../services/pfm-main.service';
@Injectable()
export class PfmfundsService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService,
  private _pfmMainService:PfmMainService) { }
  create(payload: Pfmfunds): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/pfmfunds');
      let bodyContent = {"pfmfunds":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: Pfmfunds): FindByKeyFn<Pfmfunds|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/pfmfunds/{inventoryNumber}');
       httpRequest.addPathParameter('inventoryNumber', key.inventoryNumber);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.pfmfunds ?? null),catchError((err:any) => {
              return of(null)
            }));

    };
  }

  delete(inventoryNumber):Observable<any> {

    const httpRequest = new HttpRequest();
    httpRequest.setResource('/pfmfunds/{inventoryNumber}');
     httpRequest.addPathParameter('inventoryNumber', inventoryNumber);
   httpRequest.setMethod('DELETE');
   httpRequest.setServerContext(environment.transfersPublisher);
    // let bodyContent = {"billeraccount":payload};
    // httpRequest.setBody(bodyContent);
    return this._httpProvider.invokeRestApi(httpRequest)

}

  modify(payload: Pfmfunds): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/pfmfunds/{inventoryNumber}');
       httpRequest.addPathParameter('inventoryNumber', payload.inventoryNumber);
     httpRequest.setMethod('PUT');
      let bodyContent = {"pfmfunds":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }


 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Pfmfunds[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/pfmfunds');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('GET');
      // if(criteriaQuery.getQueryparam('period')){
        // httpRequest.addQueryParameter('period',criteriaQuery.getQueryparam('period'));
        httpRequest.addQueryParameter('creditFrequency',criteriaQuery.getQueryparam('creditFrequency'));
      // }
      // else{
        let date = this._pfmMainService.currentPfmFundsDate.split('/')
        let currentPfmFundsDate= date[2]+"-"+date[1];
        httpRequest.addQueryParameter('period',currentPfmFundsDate);
      // }
      // httpRequest.addQueryParameter('creditFrequency',"1");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<PfmfundsMaintanence>) =>
              res.body.pfmfunds
          )
        );
    };
  }


     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/pfmfunds');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
}
